import axios from "axios";
//import router from "@/router";

const getDefaultState = () => {
  return {};
};

const state = getDefaultState();

const getters = {};

const actions = {
  fetchParkingStatsForRange({ commit, rootGetters }, payload) {
    return new Promise((resolve, reject) => {
      const data = {
        query: `
          query {
            parkingStatsForPeriod (
              date_from: "${payload.range[0] != null ? payload.range[0] : ""}",
              date_to: "${payload.range[1] != null ? payload.range[1] : ""}"
            )
          }
        `
      };

      axios
        .post(rootGetters.getGraphQlUrl, data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            alert(res.data.errors[0].message);
          } else {
            resolve(res.data.data);
          }
        })
        .catch(err => {
          alert(err);
          console.error(err);
          reject(err);
        });
    });
  }
};

const mutations = {
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
